import styled, { css } from 'styled-components';
import { componentToken, declaration } from '../../style/utils';

export const linkStyles = css`
  color: ${componentToken('link.color')};

  &:hover {
    ${({ theme }) =>
      declaration('color', theme.tokens.components.link.hoverColor)}
  }

  ${({ theme }) =>
    theme.tokens.components.link.underlineOnlyOnHover &&
    `
      text-decoration: none;

      &:hover,
      &:focus-visible {
        text-decoration: underline;
      }
    `}
`;

const Link = styled.a`
  ${linkStyles}
`;

export default Link;
